<div class="zn-form" [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-12">
                    <div class="form-control-container">
                        <label class="form-label" for="Cycle">
                            {{`${localizationResource}::Stand.Cycle`| abpLocalization}}
                            <span class="form-label-required">*</span>
                        </label>
                        <input
                        id="Cycle"
                        class="form-control"
                        type="number"
                        formControlName="Cycle"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
                        />
                        @if (fieldInvalid('Cycle')){
                            @if(form.get('Cycle')?.hasError('required')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                            }
                            @if (form.get('Cycle')?.hasError('pattern')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeInteger` | abpLocalization}}</small>
                            }
                            @else if (form.get('Cycle')?.hasError('min')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeGreaterThan` | abpLocalization : '0'}}</small>
                            }
                        }
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-control-container">
                        <label class="form-label" for="Rotation">
                            {{`${localizationResource}::Stand.Rotation`| abpLocalization}}
                            <span class="form-label-required">*</span>
                        </label>
                        <input
                        id="Rotation"
                        class="form-control"
                        type="number"
                        formControlName="Rotation"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
                        />
                        @if (fieldInvalid('Rotation')){
                            @if(form.get('Rotation')?.hasError('required')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                            }
                            @if (form.get('Rotation')?.hasError('pattern')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeInteger` | abpLocalization}}</small>
                            }
                            @else if (form.get('Rotation')?.hasError('min')){
                                <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeGreaterThan` | abpLocalization : '0'}}</small>
                            }
                        }
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
